


































































import {Component, Prop, Watch} from "vue-property-decorator";
import {WarehouseStore} from "@/modules/warehouses/store";
import {PartnerType} from "@/enums/type";
import {StockOutTranshipmentParams} from "@/modules/warehouses/params";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {debounce, union, difference} from 'lodash';
import PLDeliveryPrint from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryPrint/index.vue";
import {assignValueToForm, getPublicPath} from "@/shared/services/helper/utils";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import PLTranshipmentPrint
    from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentPrint/index.vue";
import {PickingListTranshipmentStore} from "@/modules/pickinglisttranshipment";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import LabelTranshipmentPrint
    from "@/modules/pickinglisttranshipment/shared/component/LabelTranshipmentPrint/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import WarehouseSuggestTranshipmentTable
    from "@/modules/warehouses/shared/components/WarehouseSuggestTranshipmentTable/index.vue";
import cloneDeep from 'lodash/cloneDeep'
import {singlePickingListDeliveryByCode} from "@/modules/pickinglistdeliveries/services";
import {singleByCodePickingListTranshipment} from "@/modules/pickinglisttranshipment/services";

const form = {
    warehouseIds: [],
    postOfficeToRowGuid: undefined,
    name: "",
    boxQuantity: undefined,
    weight: undefined,
    partnerRowGuid: undefined,
    dateExpectedTo: undefined,
    pickingListCode: undefined
};
@Component({
    name: "CreateTranshipment",
    components: {
        WarehouseSuggestTranshipmentTable,
        InputCurrency,
        AInputBarCode,
        LabelTranshipmentPrint,
        MillisecondDatePicker,
        PLTranshipmentPrint,
        PostOfficeSelector,
        PartnerSelector,
        PLDeliveryPrint
    }
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly code!: string;
    PartnerType = PartnerType;
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLading.ladingCode",
            key: "ladingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Tỉnh đến",
            dataIndex: "billLading.locationTo.province.name",
            key: "locationToProvince",
            width: 120,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "billLading.weightTemp",
            key: "ladingWeight",
            width: 100,
            ellipsis: true
        },
        {
            title: "SK",
            dataIndex: "billLading.boxQuantity",
            key: "ladingBoxQuantity",
            width: 80,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "billLading.freightService.serviceCode",
            key: "ladingFreightService",
            width: 100,
            ellipsis: true
        },
        {
            title: "DV_GTGT",
            dataIndex: "billLading.freightServiceAdds",
            key: "ladingFreightServiceAdd",
            scopedSlots: {customRender: 'ladingFreightServiceAdd'},
            width: 120,
            ellipsis: true
        },
        {
            title: "Thu tiền NN",
            dataIndex: "billLading.receiverCollect",
            key: "ladingReceiverCollect",
            scopedSlots: {customRender: 'ladingReceiverCollect'},
            width: 150,
            ellipsis: true
        },
        {
            title: "Xóa",
            dataIndex: "id",
            key: "id",
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 100
        }
    ];
    printLabelTranshipmentObj = {
        id: "print-label-transhipment",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    };
    isSubmitting = false;
    ladingCode = "";
    stockOutTranshipmentParams = new StockOutTranshipmentParams();
    form = cloneDeep(form);
    pickingListTranshipmentId = null;
    pickingListDeliveryId = null;

    get title() {
        return this.code ? `Thêm đơn vào bảng kê ${this.code}` : "Phân công phát";
    }

    async created() {
        WarehouseStore.clearWarehouses();
        if (this.code) {
            const pickingList = await this.singlePickingListByCode(this.code);
            this.form = assignValueToForm(this.form, pickingList);
            this.form.pickingListCode = this.code as any;
        }
    }

    get totalLading() {
        return WarehouseStore.ids.length;
    }

    get warehouses() {
        return WarehouseStore.ids.map((id: number, index: number) => {
            const warehouse = WarehouseStore.data[id];
            warehouse['stt'] = index + 1;
            return warehouse;
        });
    }

    @Watch("form.postOfficeToRowGuid")
    async onPostOfficeRowGuid(val: any, oldVal: any) {
        this.form = this.code ? {...this.form, warehouseIds: [], postOfficeToRowGuid: val} : {...form, postOfficeToRowGuid: val};
        this.ladingCode = "";
        if (!val) {
            WarehouseStore.clearWarehouses();
            return;
        }
        try {
            this.stockOutTranshipmentParams = {...new StockOutTranshipmentParams(), postOfficeToRowGuid: val};
            await WarehouseStore.listWarehouseByLadingTranshipment(this.stockOutTranshipmentParams);
        } catch (e) {
            this.$message.error({content: e.response?.data?.message || "Đã xảy ra lỗi"})
        }
    }

    onChangeLadingCode($evt: any) {
        const ladingCode = $evt?.target?.value;
        if (!ladingCode) return;
        if (!this.form.postOfficeToRowGuid) {
            this.$message.error("Chọn bưu cục phát");
            return;
        }
        this.handleChangeLadingCode(ladingCode, this);
    }

    handleChangeLadingCode = debounce(async (ladingCode: string, vm: any) => {
        try {
            const warehouse = await WarehouseStore.scanBillLadingStockOut(ladingCode);
            if (vm.form.postOfficeToRowGuid !== vm.getProp(warehouse, 'billLading.deliveryPostOfficeSuggestRowGuid')) {
                warehouse['exception'] = true;
                WarehouseStore.addWarehouse({payload: warehouse, toTop: true})
            } else {
                WarehouseStore.addWarehouse({payload: warehouse})
            }
            vm.form.warehouseIds = union(vm.form.warehouseIds, [warehouse.id]) as any;
        } catch (e) {
            vm.$message.error(`${e.response?.data?.message || ""}`);
        } finally {
            vm.ladingCode = "";
        }
    });

    async stockOutTranshipment() {
        if (!this.isValidStockOut()) return;
        try {
            this.isSubmitting = true;
            const pickingListTranshipment =
                this.code
                    ? await WarehouseStore.addBillToPickingListTranshipment(this.form)
                    : await WarehouseStore.stockOutTranshipment(this.form);

            this.$message.success("Chuyển vùng thành công");
            PickingListTranshipmentStore.addPickingListTranshipment(pickingListTranshipment);
            this.pickingListTranshipmentId = pickingListTranshipment.id;
            this.resetForm();
            (this.$refs.btnPrintTranshipment as any).$el.click();
        } catch (e) {
            this.$message.error({content: e.response?.data?.message || "Đã có lỗi"})
        } finally {
            this.isSubmitting = false;
        }
    }

    acceptLadings() {
        const removeWarehouses = difference(WarehouseStore.ids, this.form.warehouseIds);
        WarehouseStore.deleteWarehouse(removeWarehouses);
    }

    isValidStockOut() {
        if (!this.form.warehouseIds.length) {
            this.$message.error({content: "Quét vận đơn để xuất kho"});
            return false;
        }
        if (!this.form.name) {
            this.$message.error({content: "Nhập tên chuyến thư"});
            return false;
        }
        if (!this.form.partnerRowGuid) {
            this.$message.error({content: "Chọn đối tác vận chuyển"});
            return false;
        }
        if (!this.form.weight) {
            this.$message.error({content: "Nhập trọng lượng thực tế"});
            return false;
        }
        if (!this.form.boxQuantity) {
            this.$message.error({content: "Nhập số kiện thực tế"});
            return false;
        }
        if (!this.form.dateExpectedTo) {
            this.$message.error({content: "Nhập ngày dự kiến đến"});
            return false;
        }
        return true;
    }

    onSelectChange(selectedRowKeys: number[]) {
        this.form.warehouseIds = selectedRowKeys as any;
    }

    deleteWarehouse(id: number) {
        WarehouseStore.deleteWarehouse([id]);
        this.form.warehouseIds = this.form.warehouseIds.filter((warehouseId: number) => warehouseId !== id);
    }

    resetForm() {
        this.form = this.code ? { ...this.form, warehouseIds: [] } : cloneDeep(form);
    }


    async singlePickingListByCode(code) {
        try {
            const { data } = await singleByCodePickingListTranshipment(code);
            return data.data;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }
}
